import React from "react";
import "./GlassCard.css";

const GlassCard = ({ className = "", children, hover = true }) => {
	return (
		<div className={`glass-card ${hover ? "glass-card--hover" : ""} ${className}`}>
			{children}
		</div>
	);
};

export default GlassCard;
